
//----------------------------------------------------------
// Generated file, DO NOT EDIT.
// To regenerate this file, run "GenerateConstants.cmd" .

// Generated data for the following assemblies:
// Microsoft.VisualStudio.Services.Favorites.WebApi
//----------------------------------------------------------


/// <amd-module name="Favorites/Common/Constants" />
export module FavoriteStorageScopes {
    export var Collection = "Collection";
    export var Project = "Project";
    export var Organization = "Organization";
}

export module OwnerScopeTypes {
    export var Team = "Team";
    export var User = "User";
}

